import { useState, useEffect, useCallback } from 'react';

import { getMasterAccountRoleTotals } from 'utils/API/Mis Apis/AccountsApis';

// Helper to format date as YYYY-MM-DD
const formatDate = (date) => {
    if (!date) return '';
    return date.toISOString().split('T')[0];
};

const formatRoleLabel = (role) => {
    if (!role) return '';
    return role.replace(/_/g, ' ').charAt(0).toUpperCase() + role.replace(/_/g, ' ').slice(1);
};

const fetchAccountsData = async (dateRange) => {
    try {
        const payload = {
            from_date: formatDate(dateRange.from),
            to_date: formatDate(dateRange.to)
        };
        const response = await getMasterAccountRoleTotals(payload);

        if (response?.data?.success && Array.isArray(response.data.data)) {
            return response.data.data.map((item, index) => ({
                id: item.role || index,
                role: item.role,
                name: formatRoleLabel(item.role),
                amount: parseFloat(item.net_amount || 0),
                debit: parseFloat(item.debit_total || 0),
                credit: parseFloat(item.credit_total || 0),
                type: ['agent', 'distributor', 'merchant'].includes(item.role?.toLowerCase())
                    ? 'payment'
                    : ['revenue', 'profit'].includes(item.role?.toLowerCase())
                    ? 'custom'
                    : 'allowance'
            }));
        }
        return [];
    } catch (error) {
        console.error('API Error in fetchAccountsData:', error);
        return [];
    }
};

export const useAccountsDashboard = () => {
    const [loading, setLoading] = useState(true);
    const [accounts, setAccounts] = useState([]);
    const [dateRange, setDateRange] = useState({
        from: new Date(),
        to: new Date()
    });

    const loadDashboardData = useCallback(async () => {
        setLoading(true);
        try {
            const data = await fetchAccountsData(dateRange);
            setAccounts(data);
        } catch (error) {
            console.error('Error fetching accounts data:', error);
        } finally {
            setLoading(false);
        }
    }, [dateRange]);

    useEffect(() => {
        loadDashboardData();
    }, [loadDashboardData]);

    const handleDateChange = (type, value) => {
        setDateRange((prev) => ({ ...prev, [type]: value }));
    };

    return {
        loading,
        accounts,
        dateRange,
        handleDateChange,
        refreshData: loadDashboardData
    };
};
